import React from 'react';

import SectionHeader from '@marketing/components/section_header';

import AppStoreIcon from './assets/app_store_icon.svg';
import DeviceIcon from './assets/device_icon.svg';
import FlashcardApp from './assets/flashcard_app.png';
import PlayStoreIcon from './assets/play_store_icon.svg';
import PrepApp from './assets/prep_app.png';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l">
      <SectionHeader
        reveal
        subtitle="Review key concepts and formulas with our Flashcard App or dive into lessons and practice using the Prep-on-the-Go App."
        supertitle="Mobile apps"
        supertitleIcon={DeviceIcon}
        title="Turn any free minute into study time"
      />

      <div className="d-flex justify-content-center">
        <div
          className="d-flex gap-m u-padding-H-m u-padding-V-s"
          style={{ border: '1px solid #F2F2F2', borderRadius: 50 }}
        >
          <div>
            <img
              alt="App Store icon"
              loading="lazy"
              src={AppStoreIcon}
            />
          </div>

          <div style={{ background: '#E5E5E5', height: '100%', width: 1 }} />

          <div>
            <img
              alt="Play Store icon"
              loading="lazy"
              src={PlayStoreIcon}
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column flex-lg-row gap-l">
        <div className="d-flex flex-1 flex-column gap-m">
          <div>
            <h4 className="text-center text-inter u-margin-T-n" style={{ color: '#4D4D4D', fontSize: 24 }}>
              <strong>Flashcard App</strong>
            </h4>

            <div className="text-center text-inter" style={{ fontSize: 15 }}>
              Study math concepts and formulas proven to raise your score.
            </div>
          </div>

          <div>
            <img
              alt="Examples of the UI and vocabulary words you'll see in the flashcard app"
              loading="lazy"
              src={FlashcardApp}
            />
          </div>
        </div>

        <div className="d-flex flex-1 flex-column gap-m">
          <div>
            <h4 className="text-center text-inter u-margin-T-n" style={{ color: '#4D4D4D', fontSize: 24 }}>
              <strong>Prep-on-the-Go App</strong>
            </h4>

            <div className="text-center text-inter" style={{ fontSize: 15 }}>
              Access our video lessons & practice questions anytime.
            </div>
          </div>

          <div>
            <img
              alt="Examples of the UI and vocabulary words you'll see in the flashcard app"
              loading="lazy"
              src={PrepApp}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
